const isIE = userAgent =>
    /Trident\/7\.0.*rv:([0-9.]+).*\).*Gecko$/.test(userAgent) ||
    /MSIE\s([0-9.]+);.*Trident\/[4-7].0/.test(userAgent) ||
    /MSIE\s(7.0)/.test(userAgent);

// eslint-disable-next-line import/prefer-default-export
export const detectIE = () => {
    if (window && typeof window.navigator !== 'undefined') {
        return isIE(window.navigator.userAgent);
    }
    return false;
};
